export type ThemeId =
  | 'GENESIS'
  | 'MIDNIGHT'
  | 'GRAPHITE'
  | 'LIGHT'

export interface GenesisTheme {
  id: ThemeId
  label: string

  variables:
    Record<string, string>
}

export const THEMES:
GenesisTheme[] = [
  {
    id: 'GENESIS',
    label: 'Genesis Dark',

    variables: {
      '--bg-root':
        '#06111a',

      '--bg-panel':
        '#071622',

      '--bg-soft':
        '#0a1d29',

      '--border':
        '#193847',

      '--text':
        '#e4edf5',

      '--muted':
        '#7893a2',

      '--accent':
        '#27b8bd',

      '--success':
        '#4bdcb2',
    },
  },

  {
    id: 'MIDNIGHT',
    label: 'Midnight',

    variables: {
      '--bg-root':
        '#030711',

      '--bg-panel':
        '#080d1c',

      '--bg-soft':
        '#0e1730',

      '--border':
        '#203463',

      '--text':
        '#edf2ff',

      '--muted':
        '#8394be',

      '--accent':
        '#4d83ff',

      '--success':
        '#4fe0bd',
    },
  },

  {
    id: 'GRAPHITE',
    label: 'Graphite',

    variables: {
      '--bg-root':
        '#111416',

      '--bg-panel':
        '#181c1f',

      '--bg-soft':
        '#20262a',

      '--border':
        '#394247',

      '--text':
        '#eef2f3',

      '--muted':
        '#9aa5aa',

      '--accent':
        '#4fc5c1',

      '--success':
        '#62d59f',
    },
  },

  {
    id: 'LIGHT',
    label: 'Light Professional',

    variables: {
      '--bg-root':
        '#eef3f6',

      '--bg-panel':
        '#ffffff',

      '--bg-soft':
        '#f4f7f9',

      '--border':
        '#cad6dd',

      '--text':
        '#15242d',

      '--muted':
        '#607783',

      '--accent':
        '#087f8c',

      '--success':
        '#187d5a',
    },
  },
]

export function getTheme(
  id: ThemeId,
) {
  return (
    THEMES.find(
      item =>
        item.id === id,
    ) ??
    THEMES[0]
  )
}
